export const updateChannelConstants = {
    CHANNEL_MAPPING_ADD_PENDING  : 'CHANNEL_MAPPING_ADD_PENDING',
    CHANNEL_MAPPING_ADD_FULFILLED: 'CHANNEL_MAPPING_ADD_FULFILLED',
    CHANNEL_MAPPING_ADD_REJECTED : 'CHANNEL_MAPPING_ADD_REJECTED',
};
